module.exports = __webpack_public_path__ + "static/media/ls-desktop-and-web-iconography.d79bd5b3.ttf";